import omitEmpty from 'omit-empty'

export const sanitizeParams = ({
  org,
  programName,
  isNspaMember,
  announcementDateRange,
  closeDateRange,
  lastVerifiedOnRange,
  openDateRange,
  recheckCompletedAtRange,
  ...rest
} = {}) => {
  return {
    ...omitEmpty({
      ...Object.keys(rest).reduce((acc, key) => {
        if (rest[key] !== false) acc[key] = rest[key]
        return acc
      }, {}),
      organizationTypes: rest?.organizationTypes?.map(
        ( elementValue ) => elementValue
      ),
      characteristics: sanitizeCharacteristics(rest),
      programName: Array.isArray(programName) ? programName.map(( item ) => item?.programName || item ) : programName,
      organizationName: Array.isArray(org) ? org.map(( item ) => item?.name || item ) : org,
      isNspaMember:
        typeof isNspaMember === 'object' ? isNspaMember?.value : isNspaMember,
    }),
    announcementDateRange,
    closeDateRange,
    lastVerifiedOnRange,
    openDateRange,
    recheckCompletedAtRange,
  }
}

const sanitizeCharacteristics = ( values ) => {
  const characteristics = []
  
  values?.contest && characteristics.push('contest')
  values?.meritBased && characteristics.push('meritBased')
  values?.needBased && characteristics.push('needBased')

  return characteristics
}